// Unpublished Work © 2021-2025 Deere & Company.

import React from 'react';
import {FullScreenCircularProgress} from '@deere/cap-it-ui.component-library';
import {HashRouter as ReactRouter, Route} from 'react-router-dom';
import {SecurityProvider} from './providers/security-provider';
import {Provider as ReduxProvider} from 'react-redux';
import {store, persistor} from './factories/store-factory';
import PropTypes from 'prop-types';
import {PersistGate} from 'redux-persist/integration/react';
import {useWalkmeScript} from './services/insert-walkme-script';
import {HealthComponent} from './views/application/health-component';
import {processEnvSvc} from './services/process-env-svc';

export const RoutesProvider = (props) => {
    useWalkmeScript(processEnvSvc('WALKME_SCRIPT'));

    const [showHealth, setShowHealth] = React.useState(false);

    React.useEffect(() => {
        setShowHealth(true);
    }, []);

    return (
        <React.Suspense fallback={<FullScreenCircularProgress loading={true}/>}>
            <ReduxProvider store={store}>
                <PersistGate persistor={persistor}>
                    <ReactRouter>
                        {
                            showHealth &&
                            <Route
                                component={HealthComponent}
                                exact={true}
                                path='/health'
                            />
                        }
                        <SecurityProvider>
                            {props.children}
                        </SecurityProvider>
                    </ReactRouter>
                </PersistGate>
            </ReduxProvider>
        </React.Suspense>
    );
};

RoutesProvider.propTypes = {
    children: PropTypes.node
};
